module.exports = __webpack_public_path__ + "img/folha-valor.ec90592d.svg";